/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NovitusQrcodeTextDto
 */
export interface NovitusQrcodeTextDto {
    /**
     * Zawartość tekstowa do kodu QR
     * @type {string}
     * @memberof NovitusQrcodeTextDto
     */
    text: string;
    /**
     * Oznacz jako zamaskowane
     * @type {boolean}
     * @memberof NovitusQrcodeTextDto
     */
    masked: boolean;
}

/**
 * Check if a given object implements the NovitusQrcodeTextDto interface.
 */
export function instanceOfNovitusQrcodeTextDto(value: object): value is NovitusQrcodeTextDto {
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('masked' in value) || value['masked'] === undefined) return false;
    return true;
}

export function NovitusQrcodeTextDtoFromJSON(json: any): NovitusQrcodeTextDto {
    return NovitusQrcodeTextDtoFromJSONTyped(json, false);
}

export function NovitusQrcodeTextDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusQrcodeTextDto {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'],
        'masked': json['masked'],
    };
}

export function NovitusQrcodeTextDtoToJSON(value?: NovitusQrcodeTextDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'text': value['text'],
        'masked': value['masked'],
    };
}

